var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"topbar"},[_c('EnterprisesHeader')],1),(_vm.$store.state.user.hasAccessToEnterprises)?_c('Search',{ref:"search",attrs:{"old-search":true,"search-type":"enterprises"},on:{"invite":_vm.requestConnection}}):_vm._e(),_c('add-connection',{ref:"requestConnection"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }